export default "__VITE_ASSET__z19UgsnL__"